<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Vending Products
        </h4>
        <!-- <div class="d-flex align-items-center">
          <div class="search-container">
            <input
              type="text"
              class="form-control"
              placeholder="Search products..."
              [(ngModel)]="searchQuery"
              (input)="onSearchChange()"
            />
          </div>
          <div class="mr-2">
            <button
              type="button"
              class="btn btn-outline-primary"
              (click)="downloadSampleCSV()"
              ngbTooltip="Download sample CSV format"
              placement="top"
            >
              <i class="fa fa-download"></i> Sample CSV
            </button>
          </div>
          <div class="mr-2">
            <label for="csvUpload" class="btn btn-primary mb-0">
              <i class="fa fa-upload"></i> Upload CSV
            </label>
            <input
              type="file"
              id="csvUpload"
              accept=".csv"
              style="display: none"
              (change)="uploadProductsFromCSV($event)"
            />
          </div>
          <a
            href="javascript: void(0);"
            class="btn btn-primary mr-2"
            placement="top"
            (click)="openModal(editModal, {}, 'Add Product')"
            ngbTooltip="Add Product"
          >
            + Add Product
          </a>
        </div> -->
      </div>

      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">EAN Number</th>
              <th scope="col">Barcode Image</th>
              <th scope="col">Product Image</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Price</th>
              <th scope="col">VAT (%)</th>
              <th scope="col">VAT Type</th>
              <th scope="col">Quantity</th>
              <th scope="col">Sold Quantity</th>
              <th scope="col">Action</th>
              <!-- 
              <th scope="col">Visible</th>
              <th scope="col">Campaign</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="categoryData?.length == 0">
              <td colspan="12" class="text-center">No products found</td>
            </tr>
            <tr *ngFor="let d of categoryData">
              <td
                (click)="openModal(editModal, d, 'Edit Product')"
                style="cursor: pointer"
              >
                {{ d.EANNumber ? d.EANNumber : "-" }}
              </td>
              <td>
                <img
                  *ngIf="d.barcodeImage"
                  [src]="d.barcodeImage"
                  alt="Product Image"
                  style="
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    cursor: pointer;
                  "
                  (click)="openImageModal(ImageModal, d.barcodeImage, true)"
                />
                <span *ngIf="!d.barcodeImage" class="text-muted">No Image</span>
              </td>
              <td>
                <img
                  *ngIf="d.productImage"
                  [src]="d.productImage"
                  (click)="openImageModal(ImageModal, d.productImage)"
                  alt="Product Image"
                  style="
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    cursor: pointer;
                  "
                />
                <span *ngIf="!d.productImage" class="text-muted">No Image</span>
              </td>
              <td>{{ d.name }}</td>
              <td>{{ d.description || "-" }}</td>
              <td>{{ currency }} {{ d.price | number : "1.2-2" }}</td>
              <td>{{ d.vat || "0" }}</td>
              <td>
                <span
                  class="badge px-3 rounded-pill"
                  style="font-size: 100%"
                  [ngClass]="d.isExclusive ? 'badge-warning' : 'badge-success'"
                >
                  {{ d.isExclusive ? "Exclusive" : "Inclusive" }}
                </span>
              </td>
              <td>{{ d.stockQuantity }}</td>
              <td>{{ d.totalSold == "0" ? "-" : d.totalSold }}</td>
              <td class="switch">
                <div class="readonly-switch-container">
                  <button
                    class="btn btn-danger"
                    style="width: 100%"
                    (click)="openUnlinkModal(unlinkModal, d)"
                  >
                    Unlink
                  </button>
                </div>
              </td>
              <!--  <td class="switch">
                <div class="readonly-switch-container">
                  <ui-switch
                    [(ngModel)]="d.visible"
                    name="visible"
                    (ngModelChange)="toggleProductVisibility(d)"
                  ></ui-switch>
                </div>
              </td>
              <td class="switch">
                <div class="readonly-switch-container">
                  <ui-switch
                    [(ngModel)]="d.isCampaign"
                    name="isCampaign"
                    (ngModelChange)="toggleProductCampaign(d)"
                  >
                  </ui-switch>
                </div>
              </td> -->

              <!-- <td>
                <a
                  href="javascript: void(0);"
                  class="link mr-2"
                  placement="top"
                  (click)="openModal(viewModal, d, 'View Product')"
                  ngbTooltip="View details"
                >
                  <i class="fa fa-eye"></i>
                </a>
                <a
                  href="javascript: void(0);"
                  class="link mr-2"
                  placement="top"
                  (click)="openModal(editModal, d, 'Edit Product')"
                  ngbTooltip="Edit"
                >
                  <i class="fa fa-edit"></i>
                </a>

                <a
                  href="javascript: void(0);"
                  class="link mr-2"
                  placement="top"
                  (click)="openModal(deleteModal, d, 'Delete Product')"
                  ngbTooltip="Delete"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </td> -->
            </tr>
          </tbody>
        </table>
        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="categoryData?.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalCount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #unlinkModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Confirm Action</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>Do you want to remove this product from this category?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmUnlink(modal)">
      Yes, Remove
    </button>
  </div>
</ng-template>
